"use strict";
/**
 * Copyright © 2019 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_sortable_hoc_1 = require("react-sortable-hoc");

var mobx_react_lite_1 = require("mobx-react-lite");

var lodash_1 = require("lodash");

var core_1 = require("@bodiless/core");

var fclasses_1 = require("@bodiless/fclasses");

var SortableChild_1 = __importDefault(require("./SortableChild"));

var SortableContainer_1 = __importDefault(require("./SortableContainer"));

var model_1 = require("./model");

var useGetMenuOptions_1 = require("./useGetMenuOptions");

var ComponentDisplayMode_1 = require("./ComponentDisplayMode");

var ChildNodeProvider = core_1.withNode(react_1.default.Fragment);
var EditFlowContainerComponents = {
  Wrapper: fclasses_1.stylable(SortableContainer_1.default),
  ComponentWrapper: fclasses_1.stylable(SortableChild_1.default)
};
/**
 * An editable version of the FlowContainer container.
 */

var EditFlowContainer = function EditFlowContainer(props) {
  var components = props.components,
      ui = props.ui,
      snapData = props.snapData,
      getDefaultWidth = props.getDefaultWidth;
  var items = model_1.useItemHandlers().getItems();

  var _a = model_1.useFlowContainerDataHandlers(),
      onFlowContainerItemResize = _a.onFlowContainerItemResize,
      setFlowContainerItems = _a.setFlowContainerItems;

  var Wrapper = components.Wrapper,
      ComponentWrapper = components.ComponentWrapper;
  var getItemUseGetMenuOptions = useGetMenuOptions_1.useGetItemUseGetMenuOptions(props);
  return react_1.default.createElement(ComponentDisplayMode_1.ComponentDisplayModeProvider, {
    mode: ComponentDisplayMode_1.ComponentDisplayMode.EditFlowContainer
  }, react_1.default.createElement(Wrapper, {
    onSortEnd: function onSortEnd(sort) {
      var oldIndex = sort.oldIndex,
          newIndex = sort.newIndex;
      setFlowContainerItems(react_sortable_hoc_1.arrayMove(items, oldIndex, newIndex));
    },
    ui: ui
  }, items.map(function (flowContainerItem, index) {
    var ChildComponent = components[flowContainerItem.type];
    if (!ChildComponent) return null;
    return react_1.default.createElement(ChildNodeProvider, {
      nodeKey: flowContainerItem.uuid,
      key: "node-" + flowContainerItem.uuid
    }, react_1.default.createElement(ComponentWrapper, {
      ui: ui,
      index: index,
      flowContainerItem: flowContainerItem,
      snapData: snapData,
      getDefaultWidth: getDefaultWidth,
      useGetMenuOptions: getItemUseGetMenuOptions(flowContainerItem),
      onResizeStop: // eslint-disable-next-line max-len
      function onResizeStop(flowContainerItemProps) {
        return onFlowContainerItemResize(flowContainerItem.uuid, flowContainerItemProps);
      }
    }, react_1.default.createElement(ChildComponent, null)));
  })));
};

EditFlowContainer.displayName = 'EditFlowContainer';
EditFlowContainer.defaultProps = {
  components: {}
};
var asEditFlowContainer = lodash_1.flowRight(core_1.withActivateOnEffect, mobx_react_lite_1.observer, fclasses_1.designable(EditFlowContainerComponents, 'FlowContainer'), core_1.withMenuOptions({
  useMenuOptions: useGetMenuOptions_1.useMenuOptions,
  name: 'Flow Container'
}), mobx_react_lite_1.observer); // Wrap the EditFlowContainer in a wthActivateContext so we can activate new items

exports.default = asEditFlowContainer(EditFlowContainer);